import "./CybersecurityDigitalTrust.module.css";
import EnTete from "@/reusable_sections/Header";
import HeroDuService from "./sections/HeroDuService";
import DetailsduService from "./sections/DetailsduService";
import CallToAction from "./sections/CallToAction";
import Footer from "@/reusable_sections/Footer";
export default function CybersecurityDigitalTrustPage() {
  return <div>
      <EnTete />
      <HeroDuService />
      <DetailsduService />
      <CallToAction />
      <Footer />
    </div>;
}